import { render } from "./LiveExpiryDate.vue?vue&type=template&id=6e4645ee"
import script from "./LiveExpiryDate.vue?vue&type=script&lang=js"
export * from "./LiveExpiryDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__